import styled from 'styled-components'
export const Wrapper = styled.div`
  .dynamicButtons {
    margin-left: auto;
    width: fit-content;
    margin-bottom: 1.25rem;
  }
`
